export default "__VITE_ASSET__DYqZ_dRM__"